export const projectHeaders = [
  {
    value: "name",
    text: "Project",
    sortable: true,
    width: 200,
  },
  {
    value: "exid",
    text: "Project ID",
    sortable: true,

    width: 40,
  },
  {
    value: "cameras",
    text: "ANPR Cameras",
    sortable: true,

    width: 40,
  },
  {
    value: "contextCameras",
    text: "Context Cameras",
    sortable: true,

    width: 40,
  },
  {
    value: "cameraStatuses",
    text: "Cameras Status",
    sortable: false,
    align: "center",
    width: 40,
  },
  {
    value: "appsStatus",
    text: "Apps Status",
    sortable: false,
    align: "center",
    width: 40,
  },
  {
    value: "postProcessingServers",
    text: "Post Processing Servers",
    sortable: false,
    align: "center",
    width: 40,
  },
  {
    value: "appsVersion",
    text: "Apps Version",
    sortable: false,
    align: "center",
    width: 40,
  },
  {
    value: "timezone",
    text: "Timezone",
    sortable: false,

    width: 40,
  },
  {
    value: "featureFlags",
    text: "Feature Flags",
    sortable: false,

    width: 80,
  },
]
